<mat-card>
    <h3>Terms & Conditions</h3>
    <p>By submitting this event you are agreeing to the conditions of Fáilte Ireland's Tourism Content System Data Contributor agreement.</p>
    <div class="terms-btn-wrapper">
      <input type="button" class="btn btn-secondary" value="View Terms & Conditions" aria-label="View Terms & Conditions" title="View Terms & Conditions" (click)="openTermsConditionsDialog()">
    </div>
</mat-card>